import { QueryClient } from '@tanstack/react-query';

import { Cart } from '@telialt/models/src/EshopModel';

import { ESHOP_QUERY_KEY } from '../model';

type DataUpdateFunction<TInput, TOutput> = (input: TInput) => TOutput;
type Updater<TInput, TOutput> = TOutput | DataUpdateFunction<TInput, TOutput>;

export const updateCart = (queryClient: QueryClient, payload: Updater<Cart, Cart>) =>
    queryClient.setQueryData([ESHOP_QUERY_KEY.CART], payload);
export const cancelCartQuery = (queryClient: QueryClient) =>
    queryClient.cancelQueries({ queryKey: [ESHOP_QUERY_KEY.CART] });
export const getCartCache = (queryClient: QueryClient) => queryClient.getQueryData<Cart>([ESHOP_QUERY_KEY.CART]);
